import { ChapterPicker } from "@/components/ChapterPicker";
import { Header } from "@/components/Header";
import { PageText } from "@/components/PageText";

export function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="mx-auto max-w-[720px] px-6 py-20">
        <p className="text-xs tracking-[0.12em] text-accent uppercase">The Bible Unleashed</p>
        <PageText
          id="home"
          titleClassName="mt-2 font-serif text-[44px] leading-[1.05] font-semibold tracking-[-0.015em] text-balance"
          bodyClassName="mt-6 font-serif text-lg leading-relaxed"
        />

        <div className="mt-10">
          <ChapterPicker />
        </div>
      </main>
    </div>
  );
}
